import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { PorscheDesignSystemProvider } from '@porsche-design-system/components-react'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'

import App from './App'

import { AUTHORITY, CLIENT_ID } from './shared/config/config'

import './index.css'

const configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: AUTHORITY
  }
}

const pca = new PublicClientApplication(configuration)

ReactDOM.render(
  <PorscheDesignSystemProvider>
    <MsalProvider instance={pca}>
      <Router>
        <App />
      </Router>
    </MsalProvider>
  </PorscheDesignSystemProvider>,
  document.getElementById('root')
)
